//@ts-nocheck
// import "@tuteria/shared-lib/src/old-admin/AdminModal/admin-modal.css";
import ClientRequestModalObserver from "@tuteria/shared-lib/src/old-admin/ClientRequestModal";
import { OldRequestStore } from "@tuteria/shared-lib/src/stores/old-request";
import { getAdapter } from "@tuteria/shared-lib/src/old-admin/utils";
import React from "react";
import ReactDOM from "@tuteria/shared-lib/src/react-dom";
import ThemeProvider from "@tuteria/shared-lib/src/bootstrap";

export const unMountSalesModal = () => {
  ReactDOM.unmountComponentAtNode(document.getElementById("rootClientRequest"));
};
export const renderSalesModal = (props, { baseUrl, userId }) => {
  console.log("PROPS", props);
  const store = OldRequestStore.create(
    {
      selectCurrency: props.selectCurrency,
      totalBudget: props.totalBudget,
      convertedTotalBudget: props.convertedTotalBudget,
      hourlyBudget: props.hourlyBudget,
      // convertedHourlyBudget: props.convertedHourlyBudget,
      instance: props,
    },
    { adapter: getAdapter(baseUrl, userId) }
  );
  ReactDOM.render(
    <ThemeProvider>
      <ClientRequestModalObserver store={store} />
    </ThemeProvider>,
    // <ClientRequestModal {...props} adapter={adapter} />,
    document.getElementById("rootClientRequest")
  );
};
